import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface DescriptionSectionProps {
  readonly description: string;
  readonly isOwner?: boolean;
  readonly createdAt?: string;
}

export default function DescriptionSection({
  description,
  isOwner,
  createdAt,
}: DescriptionSectionProps) {
  const { t } = useTranslation();

  if (!description) {
    return null;
  }

  const formattedDate = createdAt
    ? new Date(createdAt).toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    : null;

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        sx={{
          fontSize: '0.875rem',
          color: 'text.secondary',
          mb: 0.5,
        }}
      >
        {t('offerDetail.description')}
      </Typography>
      <Typography
        sx={{
          fontSize: '1rem',
          color: 'text.primary',
          whiteSpace: 'pre-wrap',
          lineHeight: 1.6,
        }}
      >
        {description}
      </Typography>
      {isOwner && formattedDate && (
        <Box sx={{ mt: 3 }}>
          <Typography sx={{ fontSize: '0.875rem', color: 'text.secondary', mb: 0.5 }}>
            {t('offerDetail.publishedAt')}
          </Typography>
          <Typography sx={{ fontSize: '1rem', color: 'text.primary' }}>{formattedDate}</Typography>
        </Box>
      )}
    </Box>
  );
}
